import React from 'react'

import images from '../../assets'

import './quemsomos.css'

const Quemsomos = () => {
  return (  
    <div className='lsk__quemsomos-parallax'>
        <div className='lsk__background-whoarewe'>
            <p> <img src= { images.arrow } alt='arrow' /> </p>
            <p className='lsk__background-whoarewe_text'> 
                Somos a <b>Lisko</b>, uma empresa especializada em Tecnologia da Informação, voltada ao desenvolvimento de soluções de <b>alta
                qualidade e confiabilidade</b>. Nascemos a partir da experiência de mais de 12 anos de seu fundador na área de TI e nos serviços
                ofertados pela empresa.
            </p>
        </div>
    </div>
  )
}

export default Quemsomos